export const API_PROJECT_URL = `${process.env.REACT_APP_API_V2_URL}/settings/application/pos/project`;
export const API_DUPLICATE_URL = `${process.env.REACT_APP_API_V2_URL}/settings/application/pos/project/duplicate`;
export const API_DISSOCIATE_URL = `${process.env.REACT_APP_API_V2_URL}/settings/application/pos/projects/dissociate`;

export const PROJECT_KEY = "PROJECT";

export const DATE_FORMAT = "DD/MM/YYYY [at] HH:mm a";
export const HOUR_FORMAT = "DD/MM/YY - HH:mm a";

export enum ProjectStatus {
    PENDING = "En attente",
    PUBLISHED = "Publié",
    PLANNED = "Planifié",
}

export enum ActionType {
    ADD = "Add",
    MODIFY = "modify",
    ARCHIVE = "Archivage",
    UNARCHIVE = "Désarchivage",
    DUPLICATE = "Dupplication",
}
